/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoMajorTickComponent extends NestedOption {
    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get customTickValues(): Array<number> {
        return this._getOption('customTickValues');
    }
    set customTickValues(value: Array<number>) {
        this._setOption('customTickValues', value);
    }

    
    get length(): number {
        return this._getOption('length');
    }
    set length(value: number) {
        this._setOption('length', value);
    }

    
    get showCalculatedTicks(): boolean {
        return this._getOption('showCalculatedTicks');
    }
    set showCalculatedTicks(value: boolean) {
        this._setOption('showCalculatedTicks', value);
    }

    
    get tickInterval(): number {
        return this._getOption('tickInterval');
    }
    set tickInterval(value: number) {
        this._setOption('tickInterval', value);
    }

    
    get useTicksAutoArrangement(): boolean {
        return this._getOption('useTicksAutoArrangement');
    }
    set useTicksAutoArrangement(value: boolean) {
        this._setOption('useTicksAutoArrangement', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    
    get width(): number {
        return this._getOption('width');
    }
    set width(value: number) {
        this._setOption('width', value);
    }

    protected get _optionPath() {
        return 'majorTick';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-major-tick',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'color': [{ type: Input },],
'customTickValues': [{ type: Input },],
'length': [{ type: Input },],
'showCalculatedTicks': [{ type: Input },],
'tickInterval': [{ type: Input },],
'useTicksAutoArrangement': [{ type: Input },],
'visible': [{ type: Input },],
'width': [{ type: Input },],
};
}


export class DxoMajorTickModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoMajorTickComponent
  ],
  exports: [
    DxoMajorTickComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
